import SingleModelInterface from '../../types/singleModelInterface'
import Option from './Option'
import getOptions from './getOptions'

export default function getCarTypesOptions(
    models: SingleModelInterface[]
): Option {
    if (typeof models === 'undefined') {
        return {}
    }

    const modelCategories = models.map((model) => model.category.name)

    return getOptions(modelCategories)
}
